import { isAboveDate } from './isAboveDate';

const THRESHOLD_DAY = 14;
const THRESHOLD_MONTH = 11;
const POLICY_START_MAX_MONTH_INDEX = 11;
const POLICY_START_MAX_DAY = 31;

export const getEngineerPolicyStartMaxDate = () => {
  const currentYear = new Date()
    .getFullYear();

  const policyStartYear = isAboveDate(THRESHOLD_DAY, THRESHOLD_MONTH) ? currentYear + 1 : currentYear;

  return new Date(
    policyStartYear, POLICY_START_MAX_MONTH_INDEX, POLICY_START_MAX_DAY,
  );
};
